<template>
  <div class="Ramucirumab">
    <div class="title" @click="open('newRamucirumab')">
      雷其他获批本癌种药物提示
      <i
        class="iconfont icon-right_medium"
        :class="isOpen == false ? 'icon-right_medium' : 'icon-down_medium'"
      ></i>
    </div>
  </div>
</template>
<script>
import RamContent from "@/components/openClose/RamContent.vue";
import isiOS from "@/utils/iosAn";
export default {
  components: {
    RamContent,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open(name) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name }));
      }
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.Ramucirumab {
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  .text {
    padding: 10px 24px 30px;
    font-size: 15PX;
    font-family: @family;
    font-weight: 400;
    color: #5f697d;
    line-height: 30px;
  }
  .title {
    height: 70px;
    padding: 0 24px;
    line-height: 70px;
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    padding-left: 24px;
    position: relative;
    i {
      float: right;
    }
    // &::before {
    //   content: "";
    //   width: 3px;
    //   height: 14px;
    //   position: absolute;
    //   top: 50%;
    //   left: 0;
    //   margin-top: -7px;
    //   background: #2f354d;
    //   border-radius: 0px 2px 2px 0px;
    // }
  }
}
</style>
